import {availability} from './availability.mjs';
import {frameCamera, toScreen, insideRect} from './safe-frame.mjs';

export const MIN_SEARCH_ZOOM = 9;
// Closest zoom of a search with hits. Hits a few hundred metres apart show clearly separated pins with streets around them at 17 on a
// 1180 x 800 screen; fully using the screen (about 18.5) is too close. Following and centring keep NEAR_ZOOM.
export const SEARCH_MAX_ZOOM = 17;
// Share of the free area that the box of query pin and hits may fill, per axis (Max, 04.11.). The other 40 % is context around the results
// (streets, water, neighbouring stations) and keeps the outer pins and their labels away from the controls.
export const SEARCH_FILL = .6;
const distance = (a, b) => {
  const rad = Math.PI / 180, dy = (b[1] - a[1]) * rad, dx = (b[0] - a[0]) * rad;
  return Math.sin(dy / 2) ** 2 + Math.cos(a[1] * rad) * Math.cos(b[1] * rad) * Math.sin(dx / 2) ** 2;
};
// Camera of a search. `view` is {size, inner}: the map size and the area (free of controls, less the pin margins) that must hold every pin.
// The query point and the ranked hits fill it as large as possible, never closer than `cap`. A search without enough neighbours is not
// a view of the hits alone: when fewer than three matching sites are inside, the nearest three join the fit, down to MIN_SEARCH_ZOOM.
export function searchFrame(point, hitCoords, sites, filters, view, cap = SEARCH_MAX_ZOOM) {
  const base = frameCamera(point ? [point, ...hitCoords] : hitCoords, view.size, view.inner, cap, SEARCH_FILL);
  if (!point || !hitCoords.length && !sites.length) return base;
  const nearest = [];
  let visible = 0;
  for (const site of sites) {
    const counts = availability(site, filters);
    if (!counts.total || (filters.onlyFree && !counts.available)) continue;
    const coord = [site.lon, site.lat];
    if (insideRect(toScreen(coord, base, view.size), view.inner) && ++visible >= 3) return base;
    const entry = {coord, distance: distance(point, coord)};
    const i = nearest.findIndex(p => p.distance > entry.distance);
    nearest.splice(i < 0 ? nearest.length : i, 0, entry);
    if (nearest.length > 3) nearest.pop();
  }
  if (nearest.length < 3) return base;
  const wide = frameCamera([point, ...hitCoords, ...nearest.map(p => p.coord)], view.size, view.inner, base.zoom, SEARCH_FILL);
  // Do not claim a three-site view when the third site is beyond the useful search range.
  return wide.zoom >= Math.min(MIN_SEARCH_ZOOM, base.zoom) ? wide : base;
}
